import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Redirect, useHistory } from 'react-router-dom';
import { useAppDispatch } from 'stores/type';
import { Splash } from 'views/components/molecules/Splash';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { setExceptionError } from 'stores/errorSlice';
import { ROUTER_PATH } from 'views/constants';
import { useDevice } from 'views/hooks/useDevice';

export const WebclipPage: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { restoreFromWebclip } = useDevice();
  const onetimeToken = queryString.parse(location.search)[
    'webclip_onetime_token'
  ] as string;

  useEffect(() => {
    const replaceWithDelay = (path: string): void => {
      // ページ表示後に即遷移してしまうとSafariのUIが表示されてしまうので遅延させる
      setTimeout(() => {
        history.replace(path);
      }, 1000);
    };

    const checkOneTimeToken = async (onetimeToken: string): Promise<void> => {
      await restoreFromWebclip(onetimeToken)
        .then((redirectPath) => {
          replaceWithDelay(redirectPath);
        })
        .catch((e) => {
          dispatch(setExceptionError(e));
        });
    };

    if (onetimeToken) {
      checkOneTimeToken(onetimeToken);
    }
  }, [dispatch, history, onetimeToken, restoreFromWebclip]);

  if (!onetimeToken) {
    return <Redirect to={ROUTER_PATH.home} />;
  } else {
    return (
      <DefaultTemplate headerText="">
        <Splash />
      </DefaultTemplate>
    );
  }
};
